import React from 'react';
import { LockIcon, MonitorSmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
const trust = [[MonitorSmartphoneIcon, 'Digital Access'], [LockIcon, 'Secure Payment'], [ShieldCheckIcon, '7-Day Guarantee']] as const;
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-charcoal/10 bg-ivory/95 shadow-sm backdrop-blur" data-id="element-237" data-mp="1y5n9qc3l4r8e">
      <div className="bg-charcoal px-3 py-2 text-center font-display text-[10px] font-extrabold uppercase tracking-[.14em] text-ivory sm:text-xs" data-id="element-238" data-mp="2qshs93gudgj8">
        Professional stretching programming for coaches
      </div>
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-3 px-3 py-1.5 text-[10px] font-semibold text-charcoal/75 sm:gap-6 sm:text-xs" data-id="element-239" data-mp="2h2eny749sg5l">
        {trust.map(([Icon, label], index) => <React.Fragment key={label} data-id="element-240" data-mp="39jhehwwycc8t" data-mpi={index}>
            {index > 0 && <span className="text-gold-ink" aria-hidden="true" data-id="element-241" data-mp="39ksi9wqedjzx">
                •
              </span>}
            <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-242" data-mp="25hno0ac1qp9">
              <Icon className="h-3.5 w-3.5 text-forest" aria-hidden="true" data-id="element-243" data-mp="27lna61783jq" /> {label}
            </span>
          </React.Fragment>)}
      </div>
    </header>;
}